import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Alert, Button, Form, Input, Spin, Tag } from 'antd'
import {
  ALIAS_STATUS,
  getMaterialAlias,
  saveMaterialAlias,
  deleteMaterialAlias
} from '../../../../modules/materialAlias'

// คำเรียกอื่นของวัสดุมาตรฐานหนึ่งตัว (spec 017 A6–A7)
// บันทึกทันทีเมื่อกดเพิ่มหรือลบ ไม่รอปุ่ม Save ของฟอร์มวัสดุ
const MaterialAliasSection = ({ materialId }) => {
  const dispatch = useDispatch()
  const [aliases, setAliases] = useState([])
  const [text, setText] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const reload = async () => {
    setLoading(true)
    const list = await dispatch(getMaterialAlias(materialId))
    setAliases(list)
    setLoading(false)
  }

  useEffect(() => {
    setAliases([])
    setText('')
    setError('')
    if (materialId) {
      reload()
    }
    // โหลดใหม่เฉพาะเมื่อเปิดวัสดุคนละตัว
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialId])

  const save = async (alias, onSuccess) => {
    setError('')
    setLoading(true)
    const result = await dispatch(
      saveMaterialAlias({
        materialId,
        alias,
        status: ALIAS_STATUS.APPROVED
      })
    )
    if (result.success) {
      if (onSuccess) {
        onSuccess()
      }
      await reload()
    } else {
      setError(result.message)
      setLoading(false)
    }
  }

  const onAdd = () => {
    const alias = text.trim()
    if (alias) {
      save(alias, () => setText(''))
    }
  }

  const onDelete = async (alias) => {
    setError('')
    setLoading(true)
    const result = await dispatch(deleteMaterialAlias(alias.id))
    if (result.success) {
      await reload()
    } else {
      setError(result.message)
      setLoading(false)
    }
  }

  const approved = aliases.filter(
    (alias) => alias.status === ALIAS_STATUS.APPROVED
  )
  const rejected = aliases.filter(
    (alias) => alias.status === ALIAS_STATUS.REJECTED
  )

  return (
    <Form.Item
      label="คำเรียกอื่น"
      extra="ร้านค้นด้วยคำเหล่านี้แล้วจะเจอวัสดุนี้ · บันทึกทันทีที่กดเพิ่มหรือลบ และมีผลกับการค้นของร้านภายใน 5 นาที">
      <Spin spinning={isLoading}>
        <div style={{ lineHeight: '32px' }}>
          {approved.map((alias) => (
            <Tag
              key={alias.id}
              color="green"
              closable
              onClose={(e) => {
                e.preventDefault()
                onDelete(alias)
              }}>
              {alias.alias}
            </Tag>
          ))}
          {approved.length === 0 && (
            <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
              ยังไม่มีคำเรียกอื่น
            </span>
          )}
        </div>
        <div style={{ display: 'flex' }}>
          <Input
            value={text}
            maxLength={191}
            placeholder="เพิ่มคำที่ร้านใช้เรียกวัสดุนี้"
            onChange={(e) => setText(e.target.value)}
            onPressEnter={(e) => {
              // กัน Enter ไป submit ฟอร์มวัสดุทั้งฟอร์ม
              e.preventDefault()
              onAdd()
            }}
          />
          <Button
            style={{ marginLeft: 8 }}
            icon="plus"
            disabled={!text.trim()}
            onClick={onAdd}>
            เพิ่ม
          </Button>
        </div>
        {error && (
          <Alert
            style={{ marginTop: 8 }}
            type="error"
            showIcon
            message={error}
          />
        )}
        {rejected.length > 0 && (
          <div style={{ marginTop: 8, lineHeight: '32px' }}>
            <span style={{ marginRight: 8, color: 'rgba(0, 0, 0, 0.45)' }}>
              คำที่ปฏิเสธไว้
            </span>
            {rejected.map((alias) => (
              <Tag key={alias.id}>
                {alias.alias}
                <Button
                  type="link"
                  size="small"
                  style={{ padding: '0 0 0 8px', height: 'auto' }}
                  onClick={() => save(alias.alias)}>
                  อนุมัติ
                </Button>
              </Tag>
            ))}
          </div>
        )}
      </Spin>
    </Form.Item>
  )
}

MaterialAliasSection.propTypes = {
  materialId: PropTypes.number
}

MaterialAliasSection.defaultProps = {
  materialId: null
}

export default MaterialAliasSection
